import { Divider, Grid2, Skeleton, Stack } from '@/primitives';

export const LoadingTable = () => {
  return (
    <Grid2 container direction="column" spacing={2}>
      <Grid2 item>
        <Stack
          direction="row"
          divider={<Divider orientation="vertical" flexItem />}
          spacing={2}
          width="100%"
        >
          <Skeleton variant="rounded" height={30} width="25%" />
          <Skeleton variant="rounded" height={30} width="25%" />
          <Skeleton variant="rounded" height={30} width="25%" />
          <Skeleton variant="rounded" height={30} width="25%" />
        </Stack>
      </Grid2>
      <Divider orientation="horizontal" flexItem />
      <Grid2 item>
        <Stack
          width="100%"
          direction="column"
          spacing={2}
          divider={<Divider orientation="horizontal" flexItem />}
        >
          <Skeleton variant="rounded" height={50} />
          <Skeleton variant="rounded" height={50} />
          <Skeleton variant="rounded" height={50} />
          <Skeleton variant="rounded" height={50} />
        </Stack>
      </Grid2>
    </Grid2>
  );
};
